module.exports = __webpack_public_path__ + "static/media/Pink_Dolphin.ee901775.svg";